import React from 'react';
// import { LuiPopover, LuiDialog, LuiDialogBody, LuiDialogFooter, LuiDialogHeader } from 'qdt-lui';
import { LuiDialog } from 'qdt-lui';
import autobind from 'autobind-decorator';
import Header from '../pages/Header';
import QdtComponent from '../components/QdtComponent';
import GdpOverTime from '../mashup/GdpOverTime';
import GdpOverTimeMap from '../mashup/GdpOverTimeMap';
import GdpGrowth from '../mashup/GdpGrowth';
import GdpGrowthMap from '../mashup/GdpGrowthMap';
import GdpPerCapita from '../mashup/GdpPerCapita';
import GdpPerCapitaMap from '../mashup/GdpPerCapitaMap';
import ConsumerPriceIndex from '../mashup/ConsumerPriceIndex';
import PersonalIncome from '../mashup/PersonalIncome';
import PersonalIncomeMap from '../mashup/PersonalIncomeMap';
import FederalInterestRate from '../mashup/FederalInterestRate';
import EarningsPrivateEmployees from '../mashup/EarningsPrivateEmployees';
import NonFarmEmployees from '../mashup/NonFarmEmployees';
import InflationConsumerPrices from '../mashup/InflationConsumerPrices';
import InflationConsumerPricesMap from '../mashup/InflationConsumerPricesMap';
import UnemploymentRate from '../mashup/UnemploymentRate';
import UnemploymentTotal from '../mashup/UnemploymentTotal';
import UnemploymentTotalMap from '../mashup/UnemploymentTotalMap';
import HistoricalStockPrices from '../mashup/HistoricalStockPrices';

export default class CustomTextInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false,
      mounted: false,
      component: 'GdpGrowth',
      selections: null,
      url: null,
      clearAll: false,
      dialogSelections: 1,
      dialogFilters: 1,
      iframeWidth: 500,
      iframeHeight: 350,
      checkBox: false,
      linkCopied: 'copied-text hide',
      embedCopied: 'copied-text2 hide',
    };
  }

  componentDidMount() {
    this.created();
  }

  @autobind
  setMashup(component) {
    const selections = null;
    this.setState({
      component, clearAll: true, selections,
    }, () => {
      this.createUrl();
      window.gtag('event', 'selector', {
        event_category: 'Component',
        event_label: component,
      });
    });
  }

  @autobind
  created() {
    this.createUrl();
    this.setState({ mounted: true });
  }

  @autobind
  async selected(selected) {
    const selections = selected.map(obj => ({
      field: obj.qField,
      values: obj.qSelectedFieldSelectionInfo.map(val => (val.qName)).join(','),
    }));
    await this.setState({ clearAll: false, selections });
    this.createUrl();
  }

  @autobind
  clearSelections() {
    const selections = null;
    this.createUrl();
    this.setState({ clearAll: true, selections });
  }

  @autobind
  click() {
    const { isOpen } = this.state;
    this.setState({ isOpen: !isOpen });
  }

  @autobind
  handleClose() {
    this.setState({ isOpen: false });
  }

  @autobind
  handleDialogSelections() {
    const { dialogSelections } = this.state;
    this.setState({ dialogSelections: (dialogSelections) ? 0 : 1 }, () => { this.createUrl(); });
  }

  @autobind
  handleDialogFilters() {
    const { dialogFilters } = this.state;
    this.setState({ dialogFilters: (dialogFilters) ? 0 : 1 }, () => { this.createUrl(); });
  }


  // Copies the link for the input
  @autobind
  handleCopyLink() {
    const copyText = document.getElementById('url-link');
    copyText.select();
    document.execCommand('copy');
    this.setState({ linkCopied: 'copied-text' }, () => {
      setTimeout(() => {
        this.setState({ linkCopied: 'copied-text hide' });
      }, 2000);
    });
  }

  // Copies the link for the text area
  @autobind
  handleCopy() {
    const copyText = document.getElementById('url');
    copyText.select();
    document.execCommand('copy');
    this.setState({ embedCopied: 'copied-text2' }, () => {
      setTimeout(() => {
        this.setState({ embedCopied: 'copied-text2 hide' });
      }, 2000);
    });
  }

  @autobind
  createUrl() {
    const {
      selections, component, checkBox,
    } = this.state;
    let url = `${document.location.origin}${document.location.pathname}#/d/${component}/`;
    url += `?selections=${checkBox ? 0 : 1}&filters=${checkBox ? 0 : 1}`;
    if (selections) url += `&selected=${encodeURIComponent(JSON.stringify(selections))}`;
    this.setState({ url });
  }

  @autobind
  toggleCheckbox() {
    const { checkBox } = this.state;
    this.setState({ checkBox: !checkBox }, () => this.createUrl());

    // Read-Only: selections=0&filters=0
  }

  render() {
    const {
      click, setMashup, selected, handleCopy, toggleCheckbox, handleCopyLink,
    } = this;
    const {
      mounted, component, isOpen, url, clearAll, dialogFilters, iframeWidth, iframeHeight, checkBox,
      linkCopied,
      embedCopied,
    } = this.state;
    const iframeCode = `<iframe src="${url}" width="${iframeWidth}" height="${(dialogFilters) ? iframeHeight + 50 : iframeHeight}"></iframe>`;
    // const chartCode = 'http://webapps.qlik.com/financial-indicators/#d/';
    let sourceTitle;
    let sourceHref;

    switch (component) {
      case 'UnemploymentTotal':
      case 'UnemploymentTotalMap':
      case 'InflationConsumerPrices':
      case 'InflationConsumerPricesMap':
      case 'GdpPerCapita':
      case 'GdpPerCapitaMap':
      case 'HistoricalStockPrices':
        sourceTitle = 'Qlik DataMarket';
        sourceHref = 'https://www.qlik.com/us/products/qlik-data-market';
        break;
      case 'ConsumerPriceIndex':
        sourceTitle = 'Federal Reserve Economic Data | FRED | St. Louis Fed';
        sourceHref = 'https://fred.stlouisfed.org/series/CPIAUCSL';
        break;
      case 'FederalInterestRate':
        sourceTitle = 'Federal Reserve Economic Data | FRED | St. Louis Fed';
        sourceHref = 'https://fred.stlouisfed.org/series/FEDFUNDS';
        break;
      case 'EarningsPrivateEmployees':
        sourceTitle = 'Federal Reserve Economic Data | FRED | St. Louis Fed';
        sourceHref = 'https://fred.stlouisfed.org/series/CES0500000003';
        break;
      case 'NonFarmEmployees':
        sourceTitle = 'Federal Reserve Economic Data | FRED | St. Louis Fed';
        sourceHref = 'https://fred.stlouisfed.org/series/PAYEMS';
        break;
      case 'UnemploymentRate':
        sourceTitle = 'Federal Reserve Economic Data | FRED | St. Louis Fed';
        sourceHref = 'https://fred.stlouisfed.org/series/UNRATE';
        break;
      case 'PersonalIncome':
      case 'PersonalIncomeMap':
      case 'GdpOverTime':
      case 'GdpOverTimeMap':
      case 'GdpGrowth':
      default:
        sourceTitle = 'U.S. Bureau of Economic Analysis';
        sourceHref = 'https://www.bea.gov/iTable/index_regional.cfm';
    }
    return (
      <div>
        <Header />
        <section>
          <QdtComponent type="SelectionApi" props={{}} handleGetSelected={selected} />
          {mounted &&
            <LuiDialog isOpen={isOpen} handleClose={this.handleClose}>
              <div className="row pb0">
                <div className="col-md-2 order-md-2">
                  <div onClick={this.handleClose} role="button" tabIndex={0} className="close "><img src="./assets/icon_X_close.svg" alt="close" /></div>
                </div>
                <div className="col-md-10 order-md-1">
                  <h1>Share This Chart</h1>
                </div>

              </div>
              <div className="row pb15">
                <div className="col-md-12 social-share-row" >
                  <a className="share-btn-parent" href={`https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
                    <div className="share-btn share-facebook">
                      <i className="fab fa-facebook-f" />
                    </div>
                    <div className="share-name">facebook</div>
                  </a>
                  <a className="share-btn-parent" href={`https://twitter.com/home?status=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
                    <div className="share-btn share-twitter">
                      <i className="fab fa-twitter" />
                    </div>
                    <div className="share-name">twitter</div>
                  </a>
                  {/* https://www.linkedin.com/shareArticle?mini=true&url=  https://www.linkedin.com/sharing/share-offsite/?url=

                  https://www.linkedin.com/sharing/share-offsite/?url=http://localhost:8080/#/d/GdpGrowth/?selections=0&filters=0
                  */}
                  <a className="share-btn-parent" href={`https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
                    <div className="share-btn share-linkedin">
                      <i className="fab fa-linkedin-in" />
                    </div>
                    <div className="share-name">linkedin</div>
                  </a>
                  <a className="share-btn-parent" href={`http://www.reddit.com/submit?url=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
                    <div className="share-btn share-reddit">
                      <i className="fab fa-reddit-alien" />
                    </div>
                    <div className="share-name">reddit</div>
                  </a>
                  <a className="share-btn-parent" href={`mailto:?&body=${encodeURIComponent(url)}`} target="_blank" rel="noopener noreferrer">
                    <div className="share-btn share-email">
                      <i className="fas fa-envelope" />
                    </div>
                    <div className="share-name">email</div>
                  </a>
                </div>
              </div>
              <div className="row pb25 pb25-special">
                <div className="col-md-12">
                  <div className="share-btn-row">
                    <input type="text" className="input-full" value={url} readOnly id="url-link" />
                    <button className="share-copy-btn" onClick={handleCopyLink} >Copy</button>
                    <div className={`${linkCopied}`}>COPIED!</div>
                  </div>
                </div>
              </div>
              <div className="row pb25">

                <div className="col-md-12 order-md-1">
                  <h1>Embed This Chart</h1>
                  <div className="share-btn-row">
                    <textarea id="url" name="url" className="url" rows="3" value={iframeCode} readOnly />
                    <button className="share-copy-btn" onClick={handleCopy}>Copy</button>
                    <div className={`${embedCopied}`}>COPIED!</div>
                  </div>
                </div>
              </div>
              <div className="row pb25">
                <div className="col-md-12">
                  <div className="share-btn-row sbr-1001">
                    <div className="chart-options">
                      Chart Options:
                      <label htmlFor="chart-options-check" className="myCheckbox" onClick={() => toggleCheckbox()} onDoubleClick={e => e.preventDefault()}>
                        <input type="checkbox" name="chart-options-check" checked={checkBox} readOnly />
                        <span />
                        <i> Read Only</i>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              {/* <div className="row pb25">
                <div className="col-md-12">
                  <h4 className="orange">Do you want to include the filters?</h4>
                  <p className="d-none d-md-block d-lg-block d-xl-block text-small">You can display the filters & chart or just the chart.</p>
                  <div>
                    <div className="inline-block pr15"><input type="radio" name="filters" value="1" checked={dialogFilters} onChange={handleDialogFilters} /> Chart & filters</div>
                    <div className="inline-block"><input type="radio" name="filters" value="0" checked={!dialogFilters} onChange={handleDialogFilters} /> Just the chart</div>
                  </div>
                </div>
              </div>
              <div className="row pb0">
                <div className="col-md-12">
                  <h4 className="orange">Your Code</h4>
                  <p className="d-none d-md-block d-lg-block d-xl-block text-small">Copy & Paste the following url into an iframe on your site.</p>
                </div>
              </div>
              <div className="row pb15">
                <div className="col-md-10">
                  <textarea id="url" name="url" className="url" rows="3" value={iframeCode} readOnly />
                </div>
                <div className="col-md-2">
                  <button className="lui-button lui-button-green" onClick={handleCopy}>Copy</button>
                </div>
              </div>
              <div className="row pb15">
                <div className="col-md-12 text-center">
                  <div><input type="checkbox" name="selections" value="1" checked={dialogSelections} onChange={handleDialogSelections} /> Interactive</div>
                  <div><input type="checkbox" name="filters" value="1" checked={dialogFilters} onChange={handleDialogFilters} /> Include Filters</div>
                </div>
          </div> */}
            </LuiDialog>
          }
        </section>
        <section id="main">
          <div className="container">
            <div className="row">
              <div className="col-md-4 navigation">
                <h1>Embed a chart</h1>
                <p>This tool allows you to embed fully interactive charts directly into your website. Your readers will be able to see the data for themselves on any device.</p>
                {/* <p> Simply find the chart you want to reference and click on "Embed This Chart" button</p> */}
                <h3>Global Economic Indicators</h3>
                <ul>
                  <li><div onClick={() => setMashup('GdpGrowth')} role="button" tabIndex={0} className={(component === 'GdpGrowth' || component === 'GdpGrowthMap') ? 'active' : 'disabled'}><span className="dot" />GDP Growth</div></li>
                  <li><div onClick={() => setMashup('GdpPerCapita')} role="button" tabIndex={0} className={(component === 'GdpPerCapita' || component === 'GdpPerCapitaMap') ? 'active' : 'disabled'}><span className="dot" />GDP Per Capita</div></li>
                  <li><div onClick={() => setMashup('InflationConsumerPrices')} role="button" tabIndex={0} className={(component === 'InflationConsumerPrices' || component === 'InflationConsumerPricesMap') ? 'active' : 'disabled'}><span className="dot" />Inflation, Consumer Prices</div></li>
                  <li><div onClick={() => setMashup('UnemploymentTotal')} role="button" tabIndex={0} className={(component === 'UnemploymentTotal' || component === 'UnemploymentTotalMap') ? 'active' : 'disabled'}><span className="dot" />Unemployment, Total</div></li>
                  <li />
                </ul>
                <h3>US Economic Indicators</h3>
                <ul>
                  <li><div onClick={() => setMashup('GdpOverTime')} role="button" tabIndex={0} className={(component === 'GdpOverTime' || component === 'GdpOverTimeMap') ? 'active' : 'disabled'}><span className="dot" />GDP Over Time</div></li>
                  <li><div onClick={() => setMashup('ConsumerPriceIndex')} role="button" tabIndex={0} className={(component === 'ConsumerPriceIndex') ? 'active' : 'disabled'}><span className="dot" />Consumer Price Index</div></li>
                  <li><div onClick={() => setMashup('PersonalIncome')} role="button" tabIndex={0} className={(component === 'PersonalIncome' || component === 'PersonalIncomeMap') ? 'active' : 'disabled'}><span className="dot" />US Per Capita Personal Income</div></li>
                  <li><div onClick={() => setMashup('FederalInterestRate')} role="button" tabIndex={0} className={(component === 'FederalInterestRate') ? 'active' : 'disabled'}><span className="dot" />US Federal Interest Rate</div></li>
                  <li><div onClick={() => setMashup('EarningsPrivateEmployees')} role="button" tabIndex={0} className={(component === 'EarningsPrivateEmployees') ? 'active' : 'disabled'}><span className="dot" />Earnings for Private Employees</div></li>
                  <li><div onClick={() => setMashup('NonFarmEmployees')} role="button" tabIndex={0} className={(component === 'NonFarmEmployees') ? 'active' : 'disabled'}><span className="dot" />Non-farm Employees</div></li>
                  <li><div onClick={() => setMashup('UnemploymentRate')} role="button" tabIndex={0} className={(component === 'UnemploymentRate') ? 'active' : 'disabled'}><span className="dot" />Unemployment Rate</div></li>
                </ul>
                <h3>Financial Indicators</h3>
                <ul>
                  <li><div onClick={() => setMashup('HistoricalStockPrices')} role="button" tabIndex={0} className={(component === 'HistoricalStockPrices') ? 'active' : 'disabled'}><span className="dot" />Historical Stock Prices</div></li>
                </ul>
              </div>
              <div className="col-md-8 content">
                {(component === 'GdpOverTime' || component === 'GdpOverTimeMap') &&
                  <ul className="tabs">
                    <QdtComponent type="FieldApi" props={{ fields: ['GDP Year'] }} clearAll={clearAll} />
                    {component === 'GdpOverTimeMap' && <QdtComponent type="FieldApi" props={{ fields: ['GDP Year'] }} handleSetSelected={{ field1: 'GDP Year', values1: '@latest' }} /> }
                    <li className={(component === 'GdpOverTime') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpOverTime')} role="button" tabIndex={0}>GDP</div></li>
                    <li className={(component === 'GdpOverTimeMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpOverTimeMap')} role="button" tabIndex={0}>GDP MAP</div></li>
                  </ul>
                }
                {(component === 'ConsumerPriceIndex') &&
                  <div className=""><QdtComponent type="FieldApi" props={{ fields: ['CPI Year', 'CPI Month'] }} clearAll={clearAll} /></div>
                }
                {(component === 'PersonalIncome' || component === 'PersonalIncomeMap') &&
                  <ul className="tabs">
                    <QdtComponent type="FieldApi" props={{ fields: ['Personal Income Year'] }} clearAll={clearAll} />
                    {component === 'PersonalIncomeMap' && <QdtComponent type="FieldApi" props={{ fields: ['Personal Income Year'] }} handleSetSelected={{ field1: 'Personal Income Year', values1: '@latest' }} /> }
                    <li className={(component === 'PersonalIncome') ? 'active' : 'disabled'}><div onClick={() => setMashup('PersonalIncome')} role="button" tabIndex={0}>PERSONAL INCOME</div></li>
                    <li className={(component === 'PersonalIncomeMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('PersonalIncomeMap')} role="button" tabIndex={0}>PERSONAL INCOME MAP</div></li>
                  </ul>
                }
                {(component === 'FederalInterestRate') &&
                  <div className=""><QdtComponent type="FieldApi" props={{ fields: ['=[Interest Rate Date.autoCalendar.Year]', '=[Interest Rate Date.autoCalendar.Month]'] }} clearAll={clearAll} /></div>
                }
                {(component === 'EarningsPrivateEmployees') &&
                  <div className=""><QdtComponent type="FieldApi" props={{ fields: ['Private Employees Year', 'Private Employees Month'] }} clearAll={clearAll} /></div>
                }
                {(component === 'NonFarmEmployees') &&
                  <div className=""><QdtComponent type="FieldApi" props={{ fields: ['Non-farm Employees Year', 'Non-farm Employees Month'] }} clearAll={clearAll} /></div>
                }
                {(component === 'UnemploymentRate') &&
                  <div className=""><QdtComponent type="FieldApi" props={{ fields: ['Unemployment Year', 'Unemployment Month'] }} clearAll={clearAll} /></div>
                }
                {(component === 'GdpGrowth' || component === 'GdpGrowthMap') &&
                  <ul className="tabs">
                    <QdtComponent type="FieldApi" props={{ fields: ['=[Global Focus Year]'] }} clearAll={clearAll} />
                    {component === 'GdpGrowthMap' && <QdtComponent type="FieldApi" props={{ fields: ['Development Indicator Year'] }} handleSetSelected={{ field1: 'Development Indicator Year', values1: '@latest' }} /> }
                    <li className={(component === 'GdpGrowth') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpGrowth')} role="button" tabIndex={0}>GROWTH</div></li>
                    <li className={(component === 'GdpGrowthMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpGrowthMap')} role="button" tabIndex={0}>GROWTH MAP</div></li>
                  </ul>
                }
                {(component === 'GdpPerCapita' || component === 'GdpPerCapitaMap') &&
                  <ul className="tabs">
                    {component === 'GdpPerCapitaMap' && <QdtComponent type="FieldApi" props={{ fields: ['Development Indicator Year'] }} handleSetSelected={{ field1: 'Development Indicator Year', values1: '@latest' }} /> }
                    <li className={(component === 'GdpPerCapita') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpPerCapita')} role="button" tabIndex={0}>PER CAPITA</div></li>
                    <li className={(component === 'GdpPerCapitaMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('GdpPerCapitaMap')} role="button" tabIndex={0}>PER CAPITA MAP</div></li>
                  </ul>
                }
                {(component === 'InflationConsumerPrices' || component === 'InflationConsumerPricesMap') &&
                  <ul className="tabs">
                    {component === 'InflationConsumerPricesMap' && <QdtComponent type="FieldApi" props={{ fields: ['=If(Not IsNull(Aggr(Avg([Inflation, consumer prices (annual %)]),[Development Indicator Year])), [Development Indicator Year])'] }} /> }
                    <li className={(component === 'InflationConsumerPrices') ? 'active' : 'disabled'}><div onClick={() => setMashup('InflationConsumerPrices')} role="button" tabIndex={0}>INFLATION</div></li>
                    <li className={(component === 'InflationConsumerPricesMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('InflationConsumerPricesMap')} role="button" tabIndex={0}>INFLATION MAP</div></li>
                  </ul>
                }
                {(component === 'UnemploymentTotal' || component === 'UnemploymentTotalMap') &&
                  <ul className="tabs">
                    {component === 'UnemploymentTotalMap' && <QdtComponent type="FieldApi" props={{ fields: ['Development Indicator Year'] }} handleSetSelected={{ field1: 'Development Indicator Year', values1: '@latest' }} /> }
                    <li className={(component === 'UnemploymentTotal') ? 'active' : 'disabled'}><div onClick={() => setMashup('UnemploymentTotal')} role="button" tabIndex={0}>UNEMPLOYMENT TOTAL</div></li>
                    <li className={(component === 'UnemploymentTotalMap') ? 'active' : 'disabled'}><div onClick={() => setMashup('UnemploymentTotalMap')} role="button" tabIndex={0}>UNEMPLOYMENT TOTAL MAP</div></li>
                  </ul>
                }
                {(component === 'HistoricalStockPrices') &&
                  <div className="">
                    <QdtComponent
                      type="FieldApi"
                      props={{ fields: ['=[Stock Year]', '=[Stock Exchange]'] }}
                      handleSetSelected={{
                      field1: 'Stock Year', values1: '2018', field2: 'Stock Exchange', values2: 'NYSE',
                    }}
                    />
                  </div>
                }
                {component === 'GdpOverTime' && <GdpOverTime />}
                {component === 'GdpOverTimeMap' && <GdpOverTimeMap />}
                {component === 'GdpGrowth' && <GdpGrowth />}
                {component === 'GdpGrowthMap' && <GdpGrowthMap />}
                {component === 'GdpPerCapita' && <GdpPerCapita />}
                {component === 'GdpPerCapitaMap' && <GdpPerCapitaMap />}
                {component === 'ConsumerPriceIndex' && <ConsumerPriceIndex />}
                {component === 'PersonalIncome' && <PersonalIncome />}
                {component === 'PersonalIncomeMap' && <PersonalIncomeMap />}
                {component === 'FederalInterestRate' && <FederalInterestRate />}
                {component === 'EarningsPrivateEmployees' && <EarningsPrivateEmployees />}
                {component === 'NonFarmEmployees' && <NonFarmEmployees />}
                {component === 'InflationConsumerPrices' && <InflationConsumerPrices />}
                {component === 'InflationConsumerPricesMap' && <InflationConsumerPricesMap />}
                {component === 'UnemploymentRate' && <UnemploymentRate />}
                {component === 'UnemploymentTotal' && <UnemploymentTotal />}
                {component === 'UnemploymentTotalMap' && <UnemploymentTotalMap />}
                {component === 'HistoricalStockPrices' && <HistoricalStockPrices />}

                <div className="row pt15 pb15 source">
                  <div className="col-md-12 text-right text-small">
                    Source: <a href={sourceHref} target="_blank" rel="noopener noreferrer">{sourceTitle}</a>
                  </div>
                </div>

                <div className="row pt15">

                  <div className="col-12 text-center">
                    <button className="lui-button lui-button-green" onClick={click}>Share/Embed This Chart</button>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </section>
        <section id="footer">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-md-9">
                <h1>Need more?</h1>
                <p className="pb30">Do you need something more than what's here? We offer an Application Placement service where we work with you to make bespoke solutions for your site.</p>
              </div>
              <div className="col-md-3 text-right">
                <p><a href="https://demos.qlik.com/app-placement" className="lui-button lui-button-green" >Learn more</a></p>
              </div>
            </div>
            <div className="row pt15 text-small">
              <div className="col">
                © 1993-2018 QlikTech International AB, All Rights Reserved
              </div>
              <div className="col d-none d-md-block d-lg-block d-xl-block text-right"><a href="https://www.qlik.com/us/legal/legal-policies">Legal Policies</a>
                <a href="https://www.qlik.com/us/legal/trademarks">Trademarks</a>
                <a href="https://www.qlik.com/us/legal/terms-of-use">Terms of use</a>
              </div>

            </div>
          </div>
        </section>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.jsx